(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('factorySettingService', factorySettingService);

	factorySettingService.$inject = ['$http', 'URLS'];

	function factorySettingService($http, URLS) {
		var baseUrl = '/api/2/factndx/{0}/FactoryControlVariables/';

		return {
			getFactorySettings: getFactorySettings,
			saveFactorySettings: saveFactorySettings,
			getFactoryGeneralSettings: getFactoryGeneralSettings,
			saveFactoryGeneralSettings: saveFactoryGeneralSettings,
			getDaysDisplay: getDaysDisplay,
			saveDaysDisplay: saveDaysDisplay,
			getCurrencies: getCurrencies,
			getTimeZones: getTimeZones,
			getFactoryCurrencyConversions: getFactoryCurrencyConversions,
			addCurrencyConversion: addCurrencyConversion,
			updateCurrencyConversionFactor: updateCurrencyConversionFactor,
			deleteCurrencyConversionMapping: deleteCurrencyConversionMapping,
			getEntitiesOrDivisionsOrBusinessUnitsByCustomer: getEntitiesOrDivisionsOrBusinessUnitsByCustomer,
			saveFactoryProjectSavingsSettings: saveFactoryProjectSavingsSettings
		};

		// accepts a setting name or an array of setting names
		// use the enum names from FactorySettingsEnum.java
		function getFactorySettings(settingNames, siteId, bySite) {
			if (typeof (settingNames) === 'string') {
				settingNames = [settingNames];
			}

			siteId = (typeof siteId === 'undefined' ? globalConfig.factory.id : siteId);
			var url = String.format('/api/2/factndx/{0}/FactoryControlVariables/', siteId) + '?settingNames=' + settingNames;
			return $http.get(url)
				.then(getFactorySettingSuccess, getFactorySettingError);

			function getFactorySettingSuccess(response) {
				return (!bySite ? response.data[siteId] : response.data);
			}
			function getFactorySettingError(error) {
				return error;
			}
		}

		function getFactoryGeneralSettings(siteId) {
			var url = '/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/FactoryGeneralSettings';

			return $http.get(url)
				.then(getFactoryGeneralSettingSuccess, getFactoryGeneralSettingError);

			function getFactoryGeneralSettingSuccess(response) {
				return response.data;
			}
			function getFactoryGeneralSettingError(error) {
				return error;
			}
		}

		// pass multiple settings as a dictionary
		function saveFactorySettings(settings, siteId) {
			var settingsList = [];
			for (var setting in settings) {
				if (settings.hasOwnProperty(setting)) {
					settingsList.push({
						name: setting,
						value: settings[setting]
					});
				}
			}
			var url = String.format(baseUrl, siteId || globalConfig.factory.id);
			return $http.post(url, settingsList)
				.then(saveFactorySettingsSuccess, saveFactorySettingsError);

			function saveFactorySettingsSuccess(response) {
				return 'Settings saved successfully';
			}
			function saveFactorySettingsError(error) {
				return 'Server error';
			}
		}

		function saveFactoryGeneralSettings(settings, siteId) {
			return $http.put('/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/FactoryGeneralSettings', settings)
				.then(saveFactoryGeneralSettingsSuccess, saveFactoryGeneralSettingsError);

			function saveFactoryGeneralSettingsSuccess(response) {
				return 'Settings saved successfully';
			}
			function saveFactoryGeneralSettingsError(error) {
				if (error && error.data && error.data.error) {
					return error.data.error;
				}
				return 'Server error';
			}
		}

		function getDaysDisplay(siteId) {
			return $http.get(URLS.host + URLS.prefix + siteId + '/FactoryControlVariables/DaysDisplay')
				.then(getDaysDisplayComplete, getDaysDisplayError);

			function getDaysDisplayComplete(response) {
				return response.data;
			}

			function getDaysDisplayError(error) {
				return undefined;
			}
		}

		function saveDaysDisplay(siteId, value) {
			return $http.put(URLS.host + URLS.prefix + siteId + '/FactoryControlVariables/DaysDisplay/DisplayType/' + value)
				.then(saveDaysDisplayComplete, saveDaysDisplayError);

			function saveDaysDisplayComplete(response) {
				return 'Settings saved successfully';
			}

			function saveDaysDisplayError(error) {
				return 'Server error';
			}
		}

		function getCurrencies(siteId) {
			var url = '/api/2/Dimensions/factndx/' + (siteId || globalConfig.factory.id) + '/Currencies';

			return $http.get(url)
				.then(getCurrenciesSuccess, getCurrenciesError);

			function getCurrenciesSuccess(response) {
				return response.data;
			}
			function getCurrenciesError(error) {
				return error;
			}
		}

		function getTimeZones(siteId) {
			var url = '/api/2/Dimensions/factndx/' + (siteId || globalConfig.factory.id) + '/TimeZones';

			return $http.get(url)
				.then(getTimeZonesSuccess, getTimeZonesError);

			function getTimeZonesSuccess(response) {
				return response.data;
			}
			function getTimeZonesError(error) {
				return error;
			}
		}

		function getFactoryCurrencyConversions(siteId) {
			var url = '/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/FactoryControlVariables/CurrencyConversions';

			return $http.get(url)
				.then(getCurrencyConversionsSuccess, getCurrencyConversionsError);

			function getCurrencyConversionsSuccess(response) {
				return response.data;
			}
			function getCurrencyConversionsError(error) {
				return error;
			}
		}

		function addCurrencyConversion(settings, siteId) {
			var url = '/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/FactoryControlVariables/CurrencyConversions';

			return $http.post(url, settings)
				.then(addCurrencyConversionSuccess, addCurrencyConversionError);

			function addCurrencyConversionSuccess(response) {
				return response;
			}
			function addCurrencyConversionError(error) {
				return error;
			}
		}

		function updateCurrencyConversionFactor(ndx, currencyMappingObj, siteId) {
			var url = '/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/FactoryControlVariables/CurrencyConversions/' + ndx;

			return $http.put(url, currencyMappingObj)
				.then(updateCurrencyConversionFactorSuccess, updateCurrencyConversionFactorError);

			function updateCurrencyConversionFactorSuccess(response) {
				return response;
			}
			function updateCurrencyConversionFactorError(error) {
				return error;
			}
		}

		function deleteCurrencyConversionMapping(ndx, siteId) {
			var url = '/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/FactoryControlVariables/CurrencyConversions/' + ndx;

			return $http.delete(url)
				.then(deleteCurrencyConversionMappingSuccess, deleteCurrencyConversionMappingError);

			function deleteCurrencyConversionMappingSuccess(response) {
				return 'Mapping deleted successfully';
			}
			function deleteCurrencyConversionMappingError(error) {
				return error;
			}
		}

		function getEntitiesOrDivisionsOrBusinessUnitsByCustomer(type, siteId) {
			var url = '/api/2/Dimensions/companyId/' + globalConfig.customer.id + '/' + type + 'ByCustomer';

			return $http.get(url)
				.then(getSuccess, getError);

			function getSuccess(response) {
				return response.data;
			}
			function getError(error) {
				return [];
			}
		}

		function saveFactoryProjectSavingsSettings(settings, siteId) {
			return $http.put('/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/FactoryGeneralSettings/ProjectSavingsType', settings)
				.then(saveFactoryProjectSavingsSettingsSuccess, saveFactoryProjectSavingsSettingsError);

			function saveFactoryProjectSavingsSettingsSuccess(response) {
				return 'Settings saved successfully';
			}
			function saveFactoryProjectSavingsSettingsError(error) {
				return 'Server error';
			}
		}
	}
})();
